import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map, switchMap } from 'rxjs';
import { AuthService } from '../auth.service';
import { Profile, ProfileUpdate } from 'src/app/models/profile.model';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from 'src/app/core/services/config-service';
import { AuthState } from 'src/app/store-ngxs/states/auth.state';
import { Store } from '@ngxs/store';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(
    private http: HttpClient,
    public authService: AuthService,
    private store: Store
  ) {}

  configService = inject(ConfigService);

  public getProfile(): Observable<Profile> {
    return this.store.select(AuthState.getToken).pipe(
      map((token) => {
        const clientId = token?.userName ?? '';
        return clientId;
      }),
      switchMap((clientId) => {
        const userId = this.authService.getUserId();
        const headers = new HttpHeaders({
          UserId: userId,
        });
        const url =
          this.configService.readConfig().baseUrlGateway +
          `/useraccount/userprofile`;
        return this.http.get<Profile>(url, { headers });
      })
    );
  }

  public updateProfile(profile: ProfileUpdate): Observable<any> {
    const url =
      this.configService.readConfig().baseUrlGateway +
      '/useraccount/userprofile';
    return this.http.put(url, profile, { observe: 'response' });
  }
}
